import React, { useEffect, useMemo, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import Loading from "../general/Loading";
import axios from "../../axios/axiosconf";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { Modal } from "react-bootstrap";

function PlanesAgendamiento() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [items, setItems] = useState([]);
    const [terminoBusqueda, setTerminoBusqueda] = useState("");
    const [idEliminar, setIdEliminar] = useState(null);
    const [planAccion, setPlanAccion] = useState(null);
    const [showModalAcciones, setShowModalAcciones] = useState(false);
    const [modalContainerStatus, setModalContainerStatus] = useState("");
    const [modalBackdropStatus, setModalBackdropStatus] = useState("zindex-back");
    const [toastMsg, setToastMsg] = useState("");

    const pesos = Intl.NumberFormat("es-CO", { style: "currency", currency: "COP" });

    const customTableStyles = useMemo(() => ({
        table: { style: { backgroundColor: "#fff" } },
        headRow: {
            style: {
                minHeight: "44px",
                borderBottom: "1px solid #e9eef3",
                backgroundColor: "#fafcfe",
            },
        },
        headCells: {
            style: {
                fontSize: "12px",
                fontWeight: 700,
                color: "#5f6b77",
                textTransform: "uppercase",
                letterSpacing: "0.02em",
                paddingTop: "10px",
                paddingBottom: "10px",
                justifyContent: "center",
            },
        },
        rows: {
            style: {
                minHeight: "52px",
                borderBottom: "1px solid #f1f4f8",
            },
        },
        cells: {
            style: {
                fontSize: "13px",
                color: "#2f3a45",
                justifyContent: "center",
            },
        },
        pagination: {
            style: {
                borderTop: "1px solid #eef2f6",
                minHeight: "50px",
            },
        },
    }), []);

    const abrirAcciones = (item) => {
        setPlanAccion(item);
        setShowModalAcciones(true);
    };

    const cerrarAcciones = () => {
        setShowModalAcciones(false);
        setPlanAccion(null);
    };

    const getBotones = (item) => (
        <button
            type="button"
            className="btn btn-sm plan-icon-btn plan-icon-btn--menu"
            title="Opciones"
            onClick={() => abrirAcciones(item)}
        >
            <i className="fas fa-ellipsis-h" />
        </button>
    );

    const cols = [
        { name: "Nombre", selector: (r) => r.nombre, sortable: true, center: true, width: "28%" },
        {
            name: "Valor",
            selector: (r) => pesos.format(Number(r.valor || 0)),
            sortable: true,
            center: true,
            width: "14%",
        },
        { name: "Servicios", selector: (r) => r.total_servicios, sortable: true, center: true, width: "12%" },
        { name: "Sesiones", selector: (r) => r.total_cupos, sortable: true, center: true, width: "12%" },
        {
            name: "Vigencia",
            selector: (r) => (r.vencimiento_dias ? `${r.vencimiento_dias} días` : "Sin vencimiento"),
            sortable: true,
            center: true,
            width: "16%",
        },
        {
            name: "Estado",
            center: true,
            cell: (r) => (
                <span className={`badge ${Number(r.activo) === 1 ? "badge-success" : "badge-secondary"}`}>
                    {Number(r.activo) === 1 ? "Activo" : "Inactivo"}
                </span>
            ),
            width: "10%",
        },
        { name: "Acción", center: true, cell: (r) => getBotones(r), width: "10%" },
    ];

    useEffect(() => {
        if (!localStorage.getItem("userdata")) {
            setLoggedIn(true);
            return;
        }
        const userdata = JSON.parse(localStorage.getItem("userdata"));
        axios
            .get("/get-client?uid=" + userdata.user_id)
            .then((r) => {
                if (r.status === 200) setClient(r.data);
                setLoggedIn(true);
            })
            .catch(() => setLoggedIn(true));
    }, []);

    useEffect(() => {
        if (!loggedIn) return;
        axios
            .get("/planes-agendamiento", { params: { termino: terminoBusqueda || undefined } })
            .then((res) => setItems(res.data || []))
            .catch(() => setItems([]));
    }, [loggedIn, terminoBusqueda]);

    const showModal = (id) => {
        cerrarAcciones();
        setModalContainerStatus("show");
        setModalBackdropStatus("show");
        setIdEliminar(id);
    };

    const cerrar = () => {
        setModalContainerStatus("");
        setModalBackdropStatus("zindex-back");
        setIdEliminar(null);
    };

    const eliminar = () => {
        axios
            .delete("/plan-agendamiento", { params: { id: idEliminar } })
            .then(() => {
                const nombre = items.find((i) => i.id === idEliminar)?.nombre || "";
                setItems((prev) => prev.filter((i) => i.id !== idEliminar));
                cerrar();
                setToastMsg(nombre ? `El plan ${nombre} ha sido eliminado` : "Plan eliminado");
            })
            .catch((err) => {
                cerrar();
                setToastMsg(err.response?.data?.message || "No se pudo eliminar");
            });
    };

    if (loggedIn) {
        return (
            <div className="hold-transition planes-admin-page">
                <Header client={client} />
                <Aside client={client} activelink="settings" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/parametros-agenda">Parámetros de agenda</Link></li>
                                        <li className="breadcrumb-item" key="bc4">Administrador de planes</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Administrador de Planes</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            {toastMsg && (
                                <div className="alert alert-info py-2 mb-3">{toastMsg}</div>
                            )}

                            <div
                                className="d-flex flex-wrap align-items-end justify-content-between"
                                style={{ gap: "16px", marginBottom: "30px" }}
                            >
                                <Link to="/plan-agendamiento" className="btn btn-primary">
                                   Crear Plan
                                </Link>
                                <div className="form-group mb-0" style={{ minWidth: "280px", maxWidth: "360px", flex: "1 1 280px" }}>
                                    <label htmlFor="terminoBusqueda">Buscar</label>
                                    <input
                                        type="text"
                                        name="terminoBusqueda"
                                        className="form-control"
                                        id="terminoBusqueda"
                                        value={terminoBusqueda}
                                        onChange={(e) => setTerminoBusqueda(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <DataTable
                                        columns={cols}
                                        data={items}
                                        pagination
                                        customStyles={customTableStyles}
                                        paginationComponentOptions={{
                                            rowsPerPageText: "Filas por página:",
                                            rangeSeparatorText: "de",
                                            noRowsPerPage: false,
                                            selectAllRowsItem: true,
                                            selectAllRowsItemText: "Todos",
                                        }}
                                        noDataComponent="No hay registros para mostrar"
                                        id="planes_agendamiento"
                                    />
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <Modal show={showModalAcciones} onHide={cerrarAcciones} centered dialogClassName="plan-actions-modal">
                    <Modal.Header className="plan-actions-modal__header">
                        <Modal.Title className="plan-actions-modal__title">
                            <span className="plan-actions-modal__title-icon">
                                <i className="fas fa-layer-group" />
                            </span>
                            Acciones del plan
                        </Modal.Title>
                        <button type="button" className="plan-actions-modal__close" onClick={cerrarAcciones}>
                            <i className="fas fa-times" />
                        </button>
                    </Modal.Header>
                    <Modal.Body className="plan-actions-modal__body">
                        {planAccion && (
                            <>
                                <div className="plan-actions-modal__item">
                                    <span className="plan-actions-modal__avatar">
                                        {(planAccion.nombre || "P").trim().charAt(0).toUpperCase()}
                                    </span>
                                    <div>
                                        <div className="plan-actions-modal__item-name">{planAccion.nombre}</div>
                                        <div className="plan-actions-modal__item-meta">
                                            {pesos.format(Number(planAccion.valor || 0))}
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex flex-column" style={{ gap: "9px" }}>
                                    <Link
                                        to={`/plan-agendamiento?id=${planAccion.id}`}
                                        className="btn plan-modal-action plan-modal-action--edit"
                                        onClick={cerrarAcciones}
                                    >
                                        <i className="far fa-edit mr-2" />
                                        Editar
                                    </Link>
                                    <button
                                        type="button"
                                        className="btn plan-modal-action plan-modal-action--delete"
                                        onClick={() => showModal(planAccion.id)}
                                    >
                                        <i className="fas fa-trash-alt mr-2" />
                                        Eliminar
                                    </button>
                                </div>
                            </>
                        )}
                    </Modal.Body>
                </Modal>

                <div className={"modal-container modal fade in " + modalContainerStatus}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Eliminar plan</h4>
                                <button type="button" className="close" onClick={() => cerrar()}>&times;</button>
                            </div>
                            <div className="modal-body">
                                ¿Está seguro que desea eliminar el plan seleccionado? No se puede si hay pacientes con el plan activo.
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => cerrar()}>Cancelar</button>
                                <button type="button" className="btn btn-danger" onClick={() => eliminar()}>Eliminar</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"modal-backdrop fade " + modalBackdropStatus} />

                <Footer showToast={false} delay={0} />

                <style>{`
                    .planes-admin-page .plan-icon-btn {
                        border: 1px solid transparent;
                        border-radius: 10px;
                        width: 31px;
                        height: 31px;
                        padding: 0;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        transition: all .15s ease;
                    }
                    .planes-admin-page .plan-icon-btn i {
                        font-size: 12px;
                    }
                    .planes-admin-page .plan-icon-btn--menu {
                        background: rgba(50, 58, 69, 0.1);
                        border-color: rgba(50, 58, 69, 0.18);
                        color: #2f3945;
                    }
                    .planes-admin-page .plan-icon-btn--menu:hover {
                        background: rgba(50, 58, 69, 0.16);
                        color: #202830;
                        transform: translateY(-1px);
                    }
                    .plan-modal-action {
                        border-radius: 12px;
                        font-weight: 700;
                        text-align: left;
                        border: 1px solid transparent;
                        min-height: 42px;
                        transition: all .16s ease;
                        background: transparent;
                        color: #47525e;
                    }
                    .plan-modal-action:hover {
                        transform: translateY(-1px);
                        background: rgba(50, 58, 69, 0.07);
                        border-color: rgba(50, 58, 69, 0.08);
                    }
                    .plan-modal-action--delete:hover {
                        color: #b42318;
                        background: rgba(220, 53, 69, 0.08);
                    }
                    .plan-modal-action i {
                        width: 18px;
                        text-align: center;
                    }
                    .plan-actions-modal .modal-content {
                        border: none;
                        border-radius: 14px;
                        box-shadow: 0 18px 40px rgba(20, 33, 48, 0.28);
                        overflow: hidden;
                    }
                    .plan-actions-modal__header {
                        border-bottom: 1px solid #edf2f7;
                        padding: 12px 14px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }
                    .plan-actions-modal__title {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        font-size: 1.1rem;
                        font-weight: 700;
                        color: #2b3440;
                    }
                    .plan-actions-modal__title-icon {
                        width: 28px;
                        height: 28px;
                        border-radius: 8px;
                        background: rgba(23, 162, 184, 0.13);
                        color: #148495;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 0.88rem;
                    }
                    .plan-actions-modal__close {
                        border: 0;
                        background: rgba(50, 58, 69, 0.08);
                        color: #4b5663;
                        width: 30px;
                        height: 30px;
                        border-radius: 999px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .plan-actions-modal__close:hover {
                        background: rgba(50, 58, 69, 0.15);
                        color: #28313a;
                    }
                    .plan-actions-modal__body {
                        padding: 14px;
                    }
                    .plan-actions-modal__item {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        margin-bottom: 12px;
                        padding: 10px;
                        border: 1px solid #edf2f7;
                        border-radius: 11px;
                        background: #fafcfe;
                    }
                    .plan-actions-modal__avatar {
                        width: 36px;
                        height: 36px;
                        border-radius: 10px;
                        background: rgba(23, 162, 184, 0.15);
                        color: #148495;
                        font-weight: 700;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .plan-actions-modal__item-name {
                        font-weight: 700;
                        color: #2b3440;
                    }
                    .plan-actions-modal__item-meta {
                        font-size: 0.85rem;
                        color: #70808f;
                    }
                `}</style>
            </div>
        );
    }

    return <Loading />;
}

export default PlanesAgendamiento;
